import { render, staticRenderFns } from "./DocumentApproval.vue?vue&type=template&id=30b566fa&scoped=true&"
import script from "./DocumentApproval.vue?vue&type=script&lang=js&"
export * from "./DocumentApproval.vue?vue&type=script&lang=js&"
import style0 from "./DocumentApproval.vue?vue&type=style&index=0&id=30b566fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b566fa",
  null
  
)

export default component.exports